import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import ListItem from '@material-ui/core/ListItem';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import { IVenture } from 'interfaces/venture';
import React, { ChangeEvent, memo } from 'react';
import { useObservable } from 'react-use-observable';
import RxOp from 'rxjs-operators';
import ventureService from 'services/venture';

interface IProps {
  disabled?: boolean;
  onChange: (event: ChangeEvent<{ value: number[] }>) => void;
  value: number[];
}

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.light,
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }),
)(InputBase);

const useStyles = makeStyles((theme: Theme) => ({
  margin: {
    width: '100%',
  },
  menuItems: {
    padding: theme.spacing(2)
  }
}));

const VentureSelection = (props: IProps) => {
  const classes = useStyles({});
  const { disabled, onChange, value } = props;

  const [ventures, , loading] = useObservable<IVenture[]>(() => {
    return ventureService.list({ page: 0, pageSize: Number.MAX_SAFE_INTEGER }).pipe(
      RxOp.logError(),
      RxOp.map(({ results }) => results),
      RxOp.tap((results) => onChange({
        target: {
          value: results.map(v => v.id)
        }
      } as ChangeEvent<{ value: number[] }>))
    );
  }, []);

  return (
    <ListItem disableGutters>
      {loading && 'Carregando...'}
      {!loading && !disabled && ventures && ventures.length > 0 && (
        <FormControl className={classes.margin} fullWidth>
          <Select
            value={value}
            onChange={onChange}
            input={<BootstrapInput />}
            fullWidth
            multiple
          >
            {ventures.sort((a, b) => a.id - b.id).map(({ id, name }) => (
              <MenuItem key={`venture-select-${id}`} className={classes.menuItems} value={id}>{name}</MenuItem>)
            )}
          </Select>
        </FormControl>
      )}

      {!loading && ventures && !ventures.length && ('Nenhum empreendimento cadastrado')}

    </ListItem>
  );
};

export default memo<IProps>(VentureSelection);
